import type { ScreenModule } from "../../../app/screen-module";
import { IntegrationsPage } from "../pages";

export default {
	id: "tenant-admin.integrations",
	path: "/admin/integrations",
	area: "tenant-admin",
	navGroup: "管理",
	label: "外部連携",
	roles: ["tenant_admin", "platform_admin"],
	backing: "MOCK_ONLY",
	enabled: true,
	component: IntegrationsPage,
} satisfies ScreenModule;
